import { Box, Avatar, Button, Divider, Menu, MenuItem, Typography } from '@mui/material'
import React, { FC, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import useUnit, { useWeightUnit } from '../hooks/useUnit'
import { UserType } from '../api/appAPI'
import { logout } from '../redux/appReducer'
import { connect } from 'react-redux'
import { StateType } from '../redux/store'
import { Flex } from './common/Helpers'

interface IProps {
    forProfile?: boolean

    user: undefined | UserType
    isInIframe: boolean

    logout(): void
}

const UserAvatar: FC<IProps> = props => {
    const [anchorEl, setAnchorEl] = useState<(EventTarget & Element) | null>(null)

    const { unit, setUnit } = useUnit()
    const { unit: weightUnit, setUnit: setWeightUnit } = useWeightUnit()

    const navigate = useNavigate()

    return (
        <Box sx={{
            mr: 1,
            ...(props.forProfile ? {
                position: 'absolute',
                right: 8,
                top: 0
            } : {})
        }}>
            {props.user
                ? <Avatar
                    style={{ width: 35, height: 35 }}
                    onClick={(e) => {
                        if (props.isInIframe === false)
                            setAnchorEl(e.currentTarget)
                        // props.logout() 
                    }}
                >{props.user.name[0]}</Avatar>
                : <Link to='/login' style={{ textDecoration: 'none' }}>
                    <Button color='primary' variant='contained' size='small'>Log in</Button>
                </Link>
            }

            <Menu
                anchorEl={anchorEl}
                // getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => { setAnchorEl(null) }}
                style={{ textAlign: 'center' }}
            >
                {!props.forProfile && <>
                    <Flex sx={{ px: 1 }} >
                        <Button
                            onClick={() => setUnit('cm')}
                            sx={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, flexGrow: 1 }}
                            variant={unit === 'cm' ? 'contained' : 'outlined'}
                        >CM</Button>
                        <Button
                            onClick={() => setUnit('in')}
                            sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, flexGrow: 1 }}
                            variant={unit === 'in' ? 'contained' : 'outlined'}
                        >IN</Button>
                    </Flex>
                    <Flex sx={{ px: 1, mt: 1 }} >
                        <Button
                            onClick={() => setWeightUnit('kg')}
                            sx={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, flexGrow: 1 }}
                            variant={weightUnit === 'kg' ? 'contained' : 'outlined'}
                        >KG</Button>
                        <Button
                            onClick={() => setWeightUnit('lbs')}
                            sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, flexGrow: 1 }}
                            variant={weightUnit === 'lbs' ? 'contained' : 'outlined'}
                        >LBS</Button>
                    </Flex>
                </>
                }
                <Divider sx={{ my: 1 }} />
                <MenuItem>
                    <Link to='/profile' style={{ textDecoration: 'none', color: 'black', width: '100%' }}>
                        <Typography style={{ width: '100%', textAlign: 'center' }}>Profile</Typography>
                    </Link>
                </MenuItem>
                <MenuItem onClick={() => {
                    setAnchorEl(null)
                    props.logout()

                    if (props.forProfile) {
                        navigate('/login')
                    }
                }}>
                    <Typography style={{ width: '100%', textAlign: 'center' }}>Logout</Typography>
                </MenuItem>
            </Menu>
        </Box>
    )
}

const mapStateToProps = (state: StateType) => ({
    user: state.appReducer.user,
    isInIframe: state.appReducer.isInIframe,
})

export default connect(mapStateToProps, {
    logout
})(UserAvatar)